import $ from 'jquery';
import React, { useEffect, useState, Fragment } from 'react';
import SidebarItems from './SidebarItems';
import { getApiUncategorizedItemsUrl, getUncategorizedPagesUrl } from '../../utilities/urlHelper';

const UncategorizedSidebarItem = (props) => {
    const [isOpen, setIsOpen] = useState((window.pageId || window.suggestionId) && window.categoryId === null);
    const [items, setItems] = useState();

    useEffect(() => {
        if (isOpen && !items) {
            $.get(getApiUncategorizedItemsUrl()).then(({ items }) => setItems(items));
        }
    }, [isOpen]);

    return (
        <div className="left-nav__category-container break-word">
            <div className="left-nav__item left-nav__category no-select">
                <span className="expand-caret" onMouseDown={() => setIsOpen(!isOpen)}>{ isOpen ? '⌄' : '›' }</span>
                <img className="left-nav__icon" height="16" width="16" src="/img/icons/pages-icon.svg" alt="uncategorized pages icon" />
                <a className="left-nav__text" href={getUncategorizedPagesUrl()}>Uncategorized</a>
            </div>
            {isOpen && (items == null)
                    && <div className="left-nav__loading loading">Loading items</div>}
            {isOpen && items && (items.length > 0
                ? <div className="category-pages"><SidebarItems categoryItems={items} /></div>
                : <div className="left-nav__loading">No uncategorized items</div>)}
        </div>
    );
};

export default UncategorizedSidebarItem;
